import { http } from "Utils/http";
import { useState, useEffect } from "react";
import DatatableBase from 'Components/Datatable/DatatableBase'
import { Datatable_Column } from "Components/Datatable/DatatableComponents/DatatableColumn";
import { store } from 'Store';

const PSEProdBatchInProgress = ({ refresh }) => {
  const loginState = store.getState().loginInfo;
  const token = "Bearer " + loginState.token;

  // Date format: mm/dd/yyyy hh: mm
  const handleDateFormat = (time) => {

    let date = new Date(time);
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    let hour = date.getHours();
    let min = date.getMinutes();

    return (
      <div>
        {month < 10 ? "0" + month : month}/
        {day < 10 ? "0" + day : day}/
        {year + " "}
        {hour < 10 ? "0" + hour : hour}:
        {min < 10 ? "0" + min : min}
      </div>
    )
  }

  /** Start of inProgressPSEProdBatch */
  const inProgressPSEProdBatchRowSelection = false;
  const inProgressPSEProdBatchHeader = "Production Data Submission Activity";
  const inProgressPSEProdBatchSearchFieldText = "Search by ID";
  const inProgressPSEProdBatchSortId = 'submitDate';
  const inProgressPSEProdBatchSortOrder = 'desc';

  // Flag: trigger api to reload data
  const [reloadInProgressPSEProdBatch, setReloadInProgressPSEProdBatch] = useState(false);

  // Set inProgressPSEProdBatchSortColumn state; default sort: submitDate desc
  const [inProgressPSEProdBatchSortColumn, setInProgressPSEProdBatchSortColumn] = useState({
    sortField: "submitDate",
    sortDirection: "desc"
  });

  const [selected, setSelected] = useState(
    {
      allSelected: false,
      selectedCount: 0,
      selectedRows: []
    }
  );

  const [showDeletePopup, setShowDeletePopup] = useState(false);

  // Trigger reload InProgressPSEProdBatches
  useEffect(() => {
    setReloadInProgressPSEProdBatch(refresh);
  }, [refresh]);


  /** End of inProgressPSEProdBatch */

  const getListCols = (selectedList, sortingInfo) => {
    const listColumns = [];

    const nameState = function ({ rowName }) {
      //console.log("print out getListCols", rowName);
      return { id: rowName.id };
    }
    listColumns.push(Datatable_Column({ name: "PSO ID", columnName: "submitPsoId", selectedRows: selectedList, sortable: true, sortFieldNum: 0, sortingInfo: sortingInfo }))
    listColumns.push(Datatable_Column({ name: "Batch ID", columnName: "id", selectedRows: selectedList, sortable: true, sortFieldNum: 0, isLink: true, linkData: { title: "", pathname: "/eventDataSubmission/displayBatchDetail", text: null, state: nameState }, sortingInfo: sortingInfo }))

    listColumns.push(Datatable_Column({ name: "Setting", columnName: "cfSetting", selectedRows: selectedList, sortable: true, sortFieldNum: 1, sortingInfo: sortingInfo }))
    listColumns.push(Datatable_Column({ name: "No of Files", columnName: "fileCount", selectedRows: selectedList, sortable: true, sortFieldNum: 2, sortingInfo: sortingInfo }))
    listColumns.push(Datatable_Column({ name: "Batch Status", columnName: "batchStatus", selectedRows: selectedList, sortable: true, sortFieldNum: 3, sortingInfo: sortingInfo }))
    listColumns.push(Datatable_Column({ name: "Submission Date", columnName: "submitDate", selectedRows: selectedList, sortable: true, sortFieldNum: 4, formatFunction: handleDateFormat, sortingInfo: sortingInfo }))

    return listColumns;
  }

  const getData = async (filter) => {
    var call = {
      paginationRequest: filter,
      isTestSubmission: "N"
    };

    var url = '/api/cda/inProgressBatch';

    return http.post(url, call, {
      headers: {
        "Authorization": token
      }
    });
  }

  // TODO:!!! remove
  const getDeleteBatchesText = () => {
    if (selected.selectedCount > 1) {
      return "Delete Selected Batch(es)";
    }
    else {
      return "Delete Selected Batch";
    }
  }

  const rowDisabledCriteria = (row) => {
    if (row.batchStatus == "In Progress") {
      return true;
    }
    else {
      return false;
    }
  }

  const handleShowDeletePopup = () => {
    setShowDeletePopup(true);
  }

  const handleCloseDeletePopup = () => {
    setShowDeletePopup(false);
  }

  return (
    <>
      <DatatableBase
        tableClassName="cdaProdInProgressTable"
        rowDisabledCriteria={rowDisabledCriteria}
        reload={reloadInProgressPSEProdBatch}
        setReload={setReloadInProgressPSEProdBatch}
        getData={getData}
        getListCols={getListCols}
        setSelected={setSelected}
        hasSelectableRows={inProgressPSEProdBatchRowSelection}
        searchFieldText={inProgressPSEProdBatchSearchFieldText}
        datatableHeader={inProgressPSEProdBatchHeader}
        datatableDescription={null}
        sortingColumn={inProgressPSEProdBatchSortId}
        sortingOrder={inProgressPSEProdBatchSortOrder}
      >
      </DatatableBase>
    </>
  )
}

export default PSEProdBatchInProgress;